import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandingService } from '../../service/branding.service';
import { VerificationType } from '../../shared/model/invitation';
import { BioVerifyComponent } from '../../shared/bio-verify.component';

@Component({
  selector: 'app-australian-consent',
  templateUrl: './australian-consent.component.html',
  styleUrls: ['./australian-consent.component.css']
})
export class AustralianConsentComponent extends BioVerifyComponent  implements OnInit {

  get logoUrl(): string {
    return this.brandingService.logoUrl;
  }

  get disabled(): boolean {
    return this.checked === false;
  }

  public checked = false;

  private invitationId: string;
  private captureUrl = '';


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brandingService: BrandingService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
  }

  public ngOnInit() {
    this.invitationId = this.route.snapshot.paramMap.get('invitationId');
    this.captureUrl = this.route.snapshot.queryParamMap.get('captureUrl');
  }

  public consent() {
    console.log('Consent given');
    this.document.location.href = this.captureUrl;
  }

}
